import type { DocumentObjectTypes, SearchResultContentType, OrderBy, SortBy } from '../types';

export * from './mixpanel';

export const ALGOLIA_SEARCH_DEBOUNCE_MS = 300;
export const LEARNER_SEARCH_ROOT_URL = 'learner/search';

export enum SearchParamOptions {
  QUERY = 'query',
  TYPE = 'type',
  CONTENT_SOURCE = 'contentSource',
  OFFSET = 'offset',
  UPDATED_DATE = 'updatedDate',
  TAGS = 'tags',
  SORT_BY = 'sortBy',
  SORT_ORDER = 'sortOrder',
  UPDATED_BY = 'updatedBy',
  SKILLS = 'skills',
}

export const TYPE_DICTIONARY = {
  cms_file: 'file',
  cms_link: 'link',
};

export const ACTIONS_ICON = {
  cms_file: 'total_downloads_file',
  cms_link: 'total_downloads_link',
};

export const CMS_RESULTS: DocumentObjectTypes[] = ['cms_file', 'cms_link'];
export enum SearchResultContentTypes {
  GUIDE = 'guide',
  PATH = 'path',
  LIBRARY = 'library',
  RESOURCE = 'resource',
  CHALLENGE = 'challenge',
  SCORM = 'scorm',
  CMS_LINK = 'cms_link',
  CMS_FILE = 'cms_file',
  EVENT = 'event',
  CONTENT_PROVIDER_CONTENT = 'content_provider_content',
}

export enum SearchResultContentSourceTypes {
  LINKEDIN_LEARNING = 'linkedin_learning',
  UDEMY = 'udemy',
}

export enum SectionTypes {
  GUIDE_TASK = 'guide_task',
  GUIDE_SECTION = 'guide_section',
}

const { t } = window.I18n;
export const translatedContentTypes: { [type in SearchResultContentType]: string } = {
  [SearchResultContentTypes.GUIDE]: t('common.content.guide.one'),
  [SearchResultContentTypes.PATH]: t('common.content.path.one'),
  [SearchResultContentTypes.LIBRARY]: t('common.content.university.one'),
  [SearchResultContentTypes.RESOURCE]: t('common.content.resource.one'),
  [SearchResultContentTypes.CHALLENGE]: t('common.content.challenge.one'),
  [SearchResultContentTypes.SCORM]: t('common.content.scorm.one'),
  [SearchResultContentTypes.CMS_LINK]: t('js.admin.cms.link'),
  [SearchResultContentTypes.CMS_FILE]: t('js.admin.cms.file'),
  [SearchResultContentTypes.EVENT]: t('common.content.event.one'),
  [SearchResultContentTypes.CONTENT_PROVIDER_CONTENT]: t('common.content.content.one'),
};

export const translatedContentSourceTypes: { [type in SearchResultContentSourceTypes]: string } = {
  [SearchResultContentSourceTypes.LINKEDIN_LEARNING]: t('common.content.linkedin_learning.one'),
  [SearchResultContentSourceTypes.UDEMY]: t('common.content.udemy.one'),
};

export const TAG_LIMIT = 100;
export const SKILL_LIMIT = 100;

export enum SortByOptions {
  RECENT = 'recent',
  RELEVANCE = 'relevance',
}
export enum OrderByOptions {
  ASC = 'asc',
  DESC = 'desc',
}
export const DEFAULT_SORT_BY: SortBy = 'relevance';
export const DEFAULT_SORT_ORDER: OrderBy = 'desc';
export const SORT_KEYS: SortBy[] = ['recent', 'relevance'];
export const ORDER_KEYS: OrderBy[] = ['asc', 'desc'];
